import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=2d818264&scoped=true&"
import script from "./TagSelector.vue?vue&type=script&lang=js&"
export * from "./TagSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=2d818264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d818264",
  null
  
)

export default component.exports